// GENERATED FILE - DO NOT MODIFY

export enum MessageReceiverTypeDto {
    User = "User",
    Company = "Company",
    CompanyAdmin = "CompanyAdmin",
    Location = "Location",
}